// Script to populate Firestore with menu data
import { collection, addDoc, getDocs, query, where, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';
// Import menu data is now an empty object to prevent local data from being used
import menu from '../data/menu';

/**
 * Populates the Firestore database with menu data
 * This script should be run once to initialize the database
 * It will first check if a menu already exists and only populate if no menu exists
 * This prevents overwriting any menu data that has been edited through the Admin panel
 * @returns {Promise<{success: boolean, created: boolean}>} Result object with success status and whether a new menu was created
 */
const populateFirestore = async () => {
  try {
    console.log('Starting to check Firestore menu data...');

    // Check if a menu already exists
    const menuQuery = query(collection(db, 'menu'));
    const menuSnapshot = await getDocs(menuQuery);

    // Only populate if no menu exists
    if (menuSnapshot.empty) {
      console.log('No existing menu found.');

      // We no longer populate from local data
      // Instead, direct users to create menu items through the Admin panel
      console.log('Please use the Admin panel to create menu items.');
      return { success: true, created: false };
    } else {
      console.log(`Found ${menuSnapshot.size} existing menu document(s). Keeping existing data.`);
      console.log('Menu already exists in Firestore. Use the Admin panel to make changes.');
      return { success: true, created: false };
    }
  } catch (error) {
    console.error('Error checking/populating Firestore:', error);
    return { success: false, created: false };
  }
};

// This function is now only exported and not automatically executed
// It will be called from the Admin component when needed

export default populateFirestore;
